import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-360f64a4"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "info-window-header" };
var _hoisted_2 = ["href"];
var _hoisted_3 = { class: "info-window-title-wrapper" };
var _hoisted_4 = ["href"];
var _hoisted_5 = { class: "info-window-hyperlink" };
var _hoisted_6 = { class: "info-window-row" };
var _hoisted_7 = { class: "info-window-row" };
var _hoisted_8 = { class: "info-window-row" };
var _hoisted_9 = { class: "info-window-row" };
var _hoisted_10 = { class: "info-window-row" };
var _hoisted_11 = { class: "info-window-row" };
var _hoisted_12 = { key: 0 };
var _hoisted_13 = ["href"];
var _hoisted_14 = { key: 1 };
var _hoisted_15 = { class: "info-window-row" };
var _hoisted_16 = { class: "info-window-row" };
var _hoisted_17 = ["disabled"];
import { useNotification } from 'naive-ui';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { key } from '../../../../store';
import TransportStatus from '../../../transport/TransportStatus';
import { formatAddress, formatName, formatStandardAddress, formatVehicle } from '../../../../helpers/Formatters';
import useTransportMarkerSpecs from '../../../generic/transport/useTransportMarkerSpecs';
import MarkerInfoWindow from './MarkerInfoWindow.vue';
import PiloteIcon from '../../../generic/PiloteIcon.vue';
import TransportMarker from '../../../generic/transport/TransportMarker.vue';
import PiloteModal from '../../../generic/modal/PiloteModal.vue';
var MILLISECONDS_PER_MINUTE = 60 * 1000;
export default /*#__PURE__*/ _defineComponent({
    __name: 'TransportMarkerInfoWindow',
    props: {
        transport: {
            type: Object,
            required: true,
        },
    },
    setup: function (__props) {
        var props = __props;
        var store = useStore(key);
        var t = useI18n({ useScope: 'global' }).t;
        var notification = useNotification();
        var getTeamById = computed(function () { return store.getters['teams/getTeamById']; });
        var UNKNOWN = t('transport.infoWindow.unknown');
        var canBeIncludedInAssistedAssignment = computed(function () {
            return props.transport.status === TransportStatus.PENDING;
        });
        var transportStatus = computed(function () { return (props.transport.status ? t("transport.status.".concat(props.transport.status)) : UNKNOWN); });
        var transportMarkerLabel = computed(function () {
            var label = useTransportMarkerSpecs(props.transport).label;
            return label.text || UNKNOWN;
        });
        var transportPageHyperlink = computed(function () { return "/app/transport/".concat(props.transport.transportRequestId); });
        var origin = computed(function () {
            return formatAddress(props.transport.institutionName, props.transport.street || UNKNOWN, props.transport.city || UNKNOWN);
        });
        var destination = computed(function () {
            return formatStandardAddress(props.transport.destinationStreet || UNKNOWN, props.transport.destinationCity || UNKNOWN);
        });
        var client = computed(function () { return formatName(props.transport.firstName || UNKNOWN, props.transport.lastName || UNKNOWN); });
        var vehicle = computed(function () {
            var vehicleColor = t(props.transport.vehicleColor) || UNKNOWN;
            return formatVehicle(props.transport.vehicleManufacturer || UNKNOWN, props.transport.vehicleModel || UNKNOWN, vehicleColor);
        });
        var waitTimeInMinutes = computed(function () {
            if (props.transport.createdOn) {
                var creationDate = new Date(props.transport.createdOn);
                var now = new Date();
                return "".concat(Math.round((now.getTime() - creationDate.getTime()) / MILLISECONDS_PER_MINUTE), " min");
            }
            return UNKNOWN;
        });
        var assignedTeam = computed(function () { return getTeamById.value(props.transport.teamId); });
        var assignedTeamPageHyperlink = computed(function () { var _a, _b; return "/app/team/".concat((_b = (_a = assignedTeam === null || assignedTeam === void 0 ? void 0 : assignedTeam.value) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ""); });
        var assignedTeamNumber = computed(function () { var _a; return (((_a = assignedTeam.value) === null || _a === void 0 ? void 0 : _a.number) ? "#".concat(assignedTeam.value.number) : UNKNOWN); });
        var smsSent = computed(function () { return props.transport.allocatedSmsWasSent ?
            t('transport.infoWindow.smsSent.yes') :
            t('transport.infoWindow.smsSent.no'); });
        var isExclusionModalVisible = ref(false);
        var exclusionModalTitle = computed(function () {
            var prefix = t('transport.infoWindow.assistedAssignment.exclusionModal.titlePrefix');
            var suffix = t('transport.infoWindow.assistedAssignment.exclusionModal.titleSuffix');
            return "".concat(prefix, " #").concat(props.transport.transportRequestId, " ").concat(suffix);
        });
        var showExclusionModal = function () {
            isExclusionModalVisible.value = true;
        };
        var hideExclusionModal = function () {
            isExclusionModalVisible.value = false;
        };
        var excludeFromAssistedAssignment = function () {
            isExclusionModalVisible.value = false;
            store.dispatch('transports/excludeTransportFromAssistedAssignment', props.transport.transportRequestId);
        };
        var includeInAssistedAssignment = function () {
            store.dispatch('transports/includeTransportInAssistedAssignment', {
                transportId: props.transport.transportRequestId,
                onError: function () {
                    notification['error']({
                        title: t('assignment.exclusion.error'),
                        duration: 7000,
                        closable: true,
                    });
                },
            });
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(MarkerInfoWindow, null, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("a", {
                                href: transportPageHyperlink.value,
                                target: "_blank",
                                class: "info-window-hyperlink"
                            }, [
                                _createVNode(TransportMarker, {
                                    num: transportMarkerLabel.value,
                                    status: __props.transport.status,
                                    class: "map-marker",
                                    height: 40,
                                    width: 40
                                }, null, 8 /* PROPS */, ["num", "status"])
                            ], 8 /* PROPS */, _hoisted_2),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)("transport.status.".concat(__props.transport.status))), 1 /* TEXT */),
                                _createElementVNode("a", {
                                    href: transportPageHyperlink.value,
                                    target: "_blank"
                                }, [
                                    _createElementVNode("span", _hoisted_5, "#" + _toDisplayString(__props.transport.transportRequestId), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_4)
                            ])
                        ])
                    ]; }),
                    content: _withCtx(function () { return [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('transport.infoWindow.origin')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(origin.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('transport.infoWindow.destination')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(destination.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('transport.infoWindow.client')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(client.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('transport.infoWindow.vehicle')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(vehicle.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('transport.infoWindow.waitTime')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(waitTimeInMinutes.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('transport.infoWindow.team')) + " : ", 1 /* TEXT */),
                                (assignedTeam.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                        _createElementVNode("a", {
                                            href: assignedTeamPageHyperlink.value,
                                            target: "_blank",
                                            class: "info-window-hyperlink"
                                        }, _toDisplayString(assignedTeamNumber.value), 9 /* TEXT, PROPS */, _hoisted_13)
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(t)('transport.infoWindow.unassigned')), 1 /* TEXT */))
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('transport.infoWindow.smsSent.label')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(smsSent.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('transport.infoWindow.passengerCount')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(__props.transport.nbOfPassengers), 1 /* TEXT */)
                            ])
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        (__props.transport.isExcludedFromAssistedAssignment)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: !canBeIncludedInAssistedAssignment.value,
                                class: _normalizeClass({
                                    'exclusion-button': true,
                                    'exclusion-hover': canBeIncludedInAssistedAssignment.value,
                                    'disable-cursor': !canBeIncludedInAssistedAssignment.value
                                }),
                                onClick: includeInAssistedAssignment
                            }, [
                                _createVNode(PiloteIcon, {
                                    icon: "gear",
                                    fill: "gray",
                                    class: "button-icon"
                                }),
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('transport.infoWindow.assistedAssignment.include')), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_17))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "exclusion-button exclusion-hover",
                                onClick: showExclusionModal
                            }, [
                                _createVNode(PiloteIcon, {
                                    icon: "forbidden",
                                    fill: "gray",
                                    class: "button-icon"
                                }),
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('transport.infoWindow.assistedAssignment.exclude')), 1 /* TEXT */)
                            ]))
                    ]; }),
                    _: 1 /* STABLE */
                }),
                _createVNode(PiloteModal, {
                    show: isExclusionModalVisible.value,
                    title: exclusionModalTitle.value,
                    confirm: excludeFromAssistedAssignment,
                    "confirm-label": _unref(t)('transport.infoWindow.assistedAssignment.exclusionModal.confirmLabel'),
                    close: hideExclusionModal,
                    "close-label": _unref(t)('transport.infoWindow.assistedAssignment.exclusionModal.closeLabel')
                }, null, 8 /* PROPS */, ["show", "title", "confirm-label", "close-label"])
            ]));
        };
    }
});
